import { routesMap, ROUTE_ACTIONS } from "../routes";

export enum DrawerTypes {
  channels = "channels",
  events = "events",
  preferences = "preferences",
  help = "help",
  devel = "devel",
  none = "none"
}

// Pulls the show query param out of the route metadata and sets it to our drawer type.
export default (state: DrawerTypes = DrawerTypes.none, action: {type: string, meta?: any}) => {
  if (action.type in ROUTE_ACTIONS) {
    // Only open drawers for non anonymous routes.
    const routeIsAnonymous = (routesMap[action.type] as typeof routesMap)?.anonymous??false;

    if (routeIsAnonymous) {
      return '';
    } else {
      const showParam = action?.meta?.location?.current?.query?.show;

      return (showParam in DrawerTypes) ? showParam : state;
    }
  }

  return state;
}